'use client';

import type { TextButtonProps } from '../button';
import { TextButton } from '../button';
import { openChannelTalk } from '../util/openChannelTalk';

interface TopNavigationInquiryButtonProps extends TextButtonProps {
  onClick?: () => void;
  textColor?: string;
}

export function TopNavigationInquiryButton({ onClick, textColor }: TopNavigationInquiryButtonProps) {
  return (
    <TextButton
      variant={'secondary'}
      size={'small'}
      onClick={() => {
        onClick?.();
        openChannelTalk();
      }}
      style={textColor ? { color: textColor } : undefined}
    >
      문의하기
    </TextButton>
  );
}
